export const REQUIRED_FIELDS_GROUP = ["groupName"];

export {
  hasNullRequiredField,
  normalizeTouchedKey,
  setDeepImmutable,
  toPath,
} from "../../shared/helpers/objectPath";
import { mergeColumnsWithCurrentState } from "../../shared/helpers/tableColumns";

export const updateFreightCostColumnByDataIndex = (
  columns: any[],
  dataIndex: string,
  updates: Record<string, any>,
) =>
  columns.map((column: any) =>
    column.dataIndex === dataIndex ? { ...column, ...updates } : column,
  );

export const mergeFreightCostColumnsWithCurrentState =
  mergeColumnsWithCurrentState;

export const getFreightCostPaginationAfterDelete = (
  pagination: { current: number; pageSize: number; total: number },
  deletedCount: number,
) => {
  const nextTotal = Math.max(0, (pagination.total || 0) - deletedCount);
  const maxPage = Math.max(1, Math.ceil(nextTotal / pagination.pageSize));

  return {
    ...pagination,
    current: Math.min(pagination.current, maxPage),
    total: nextTotal,
  };
};

export const getAuthorizedFreightCostTab = (
  items: Array<{ key: string; disabled?: boolean }>,
  activeTabScreen?: string | null,
) => {
  const availableTabs = items
    .filter((item) => !item.disabled)
    .map((item) => String(item.key));

  if (!availableTabs.length) {
    return null;
  }

  if (activeTabScreen && availableTabs.includes(activeTabScreen)) {
    return activeTabScreen;
  }

  return availableTabs[0];
};

export const getFreightCostListParams = ({
  activeTabs,
  activeVersion,
  pagination,
  filters,
}: {
  activeTabs: string;
  activeVersion?: string | null;
  pagination: { current: number; pageSize: number };
  filters?: Record<string, any>;
}) => ({
  current: pagination.current,
  pageSize: pagination.pageSize,
  type: activeTabs === "1" ? "TRUCK_VENDOR" : "TRUCK_VENDOR_GROUP",
  truckVendorGroup: activeTabs !== "1" ? activeTabs : "",
  version: activeVersion,
  ...(filters || {}),
});

export const getFreightCostCancelResult = (
  rows: Array<{ _id: string; status?: string }>,
  editIndex: Array<{
    index: string | number;
    record?: { status?: string; [key: string]: unknown };
  }>,
  index: string | number,
) => {
  const editItem = editIndex.find((item) => item.index === index);
  const nextEditIndex = editIndex.filter((item) => item.index !== index);
  const nextRows =
    editItem?.record?.status === "new"
      ? rows.filter((item) => item._id !== index)
      : rows;

  return {
    nextRows,
    nextEditIndex,
  };
};
